import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { LeftNavLayout } from 'containers';
import { ModalTopBar, PageHeader, Spinner } from 'components';
import { getAllClients } from 'redux/modules/teamManagement';
import { GroupPostForm, GroupPostPreview } from '../../components/GroupPost';
import RaisedButton from 'material-ui/RaisedButton';
import * as styles from './GroupPost.scss';
var GroupPostCompose = (_dec = connect(function (state) {
  return {
    allClients: state.teamManagement.allClients,
    selectedFields: state.teamManagement.selectedClientTableColumns,
    theme: state.theme
  };
}, {
  getAllClients: getAllClients
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GroupPostCompose, _Component);

  var _super = _createSuper(GroupPostCompose);

  function GroupPostCompose(props) {
    var _this;

    _classCallCheck(this, GroupPostCompose);

    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }

  _createClass(GroupPostCompose, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.allClients && !this.props.allClients.length) {
        this.props.getAllClients({
          orgTypeId: "".concat(this.props.theme.org) === '0' ? 3 : null,
          parentOrganizationId: this.props.theme.org
        });
      }
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var clientsWithSocialAccounts = this.props.allClients && !!this.props.allClients.length ? this.props.allClients.filter(function (client) {
        return client.SocialAccounts && !!client.SocialAccounts.length;
      }) : [];
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          padding: 0,
          display: 'flex'
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Group Post"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          overflow: 'hidden',
          overflowY: 'auto'
        }
      }, /*#__PURE__*/React.createElement(ModalTopBar, {
        showCloseBtn: false,
        handleClose: function handleClose() {
          console.log('handleClose()');
        },
        backLabel: "Back To Group Posts",
        handleGoBack: function handleGoBack() {
          browserHistory.push('/global/group-posts');
        },
        style: {
          position: 'static',
          display: 'block'
        }
      }), clientsWithSocialAccounts && clientsWithSocialAccounts.length ? /*#__PURE__*/React.createElement("div", {
        className: "container",
        style: {
          maxWidth: '1200px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12 col-md-6",
        style: {
          padding: '12px 40px'
        }
      }, this.props.allClients && !!this.props.allClients.length && /*#__PURE__*/React.createElement(GroupPostForm, null)), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-0 col-sm-0 col-md-6",
        style: {
          padding: '12px 40px'
        }
      }, /*#__PURE__*/React.createElement(GroupPostPreview, null)))) : /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return GroupPostCompose;
}(Component)) || _class);
export { GroupPostCompose as default };